"use client";

import * as React from "react";
import { cn } from "@/lib/utils";

export interface FormStepNavProps {
  steps: { value: string; label: string }[];
  activeStep?: string;
  onStepChange?: (value: string) => void;
}

export function FormStepNav({ steps, activeStep, onStepChange }: FormStepNavProps) {
  if (!steps.length) return null;

  return (
    <nav className="flex flex-wrap gap-2" aria-label="Form steps">
      {steps.map((step, idx) => {
        const isActive = step.value === activeStep;
        return (
          <button
            key={step.value}
            type="button"
            disabled={!onStepChange}
            onClick={() => onStepChange?.(step.value)}
            className={cn(
              "rounded-full px-3 py-1 text-xs font-medium transition-colors sm:text-sm",
              isActive
                ? "bg-indigo-600 text-white dark:bg-indigo-500"
                : "bg-slate-100 text-slate-600 hover:bg-slate-200 dark:bg-zinc-800 dark:text-zinc-300",
            )}
          >
            <span className="mr-1 opacity-70">{idx + 1}.</span>
            {step.label}
          </button>
        );
      })}
    </nav>
  );
}
